// extracted by mini-css-extract-plugin
export default {"default":"style_default__XX3fi","small":"style_small__SoKpu"};